/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseEmployees
 */
export interface GetConfig200ResponseEmployees {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseEmployees
     */
    selectionType: string;
}

/**
 * Check if a given object implements the GetConfig200ResponseEmployees interface.
 */
export function instanceOfGetConfig200ResponseEmployees(value: object): value is GetConfig200ResponseEmployees {
    if (!('selectionType' in value) || value['selectionType'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseEmployeesFromJSON(json: any): GetConfig200ResponseEmployees {
    return GetConfig200ResponseEmployeesFromJSONTyped(json, false);
}

export function GetConfig200ResponseEmployeesFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseEmployees {
    if (json == null) {
        return json;
    }
    return {
        
        'selectionType': json['selectionType'],
    };
}

export function GetConfig200ResponseEmployeesToJSON(json: any): GetConfig200ResponseEmployees {
    return GetConfig200ResponseEmployeesToJSONTyped(json, false);
}

export function GetConfig200ResponseEmployeesToJSONTyped(value?: GetConfig200ResponseEmployees | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selectionType': value['selectionType'],
    };
}

